import React from 'react';
import styled, { keyframes } from 'styled-components';

const heartBeat = keyframes`
  from {
    -webkit-transform: scale(1);
            transform: scale(1);
    -webkit-transform-origin: center center;
            transform-origin: center center;
    -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
  }
  10% {
    -webkit-transform: scale(0.91);
            transform: scale(0.91);
    -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
  }
  17% {
    -webkit-transform: scale(0.98);
            transform: scale(0.98);
    -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
  }
  33% {
    -webkit-transform: scale(0.87);
            transform: scale(0.87);
    -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
  }
  45% {
    -webkit-transform: scale(1);
            transform: scale(1);
    -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
  }
`;

const Marker = styled.div`
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #39a7ff;
  border: 2px solid white;
  -webkit-animation: ${heartBeat} 1.5s ease-in-out infinite both;
  animation: ${heartBeat} 1.5s ease-in-out infinite both;
  z-index: 10;
`;

const puffOutCenter = keyframes`
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-filter: blur(0px);
    filter: blur(0px);
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(2);
    transform: scale(2);
    -webkit-filter: blur(4px);
    filter: blur(4px);
    opacity: 0; 
  }
`;

const OuterMarker = styled.div`
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #39a7ff;
  border: 2px solid white;
  -webkit-animation: 1s ${puffOutCenter} cubic-bezier(0.165, 0.84, 0.44, 1)
    infinite both;
  animation: 1s ${puffOutCenter} cubic-bezier(0.165, 0.84, 0.44, 1) infinite
    both;
  z-index: 10;
`;

const MapMarker = () => {
  return (
    <>
      <Marker />
      <OuterMarker />
    </>
  );
};

export default MapMarker;
